import axios from '@/utils/request'

export default {
  // 2020-12-18
  all() {
    return axios.get('/couriers/all')
  },
  // 2020-08-07
  findCourierTenantByTenantId() {
    return axios.get('/couriers/tenants/find-by-tenant-id')
  },
  // // 2020-08-07
  // findByLogin(params) {
  //   return axios.get('/couriers/find-by-login', params)
  // },
  // 2020-08-07
  createCourierTenant(params) {
    return axios.post('/couriers/tenants', params)
  },
  // 2020-08-07
  deleteCourierTenant(courierTenantId) {
    return axios.delete('/couriers/tenants/' + courierTenantId)
  },

  // 2021-06-30
  fedex(params) {
    return axios.post('/couriers/tenants/fedex', params)
  },
  // 2021-08-27
  aliexpressService(params) {
    return axios.put('/couriers/tenants/aliexpress-service', params)
  },
  // 2021-10-29
  youzhengAuth(id, params) {
    return axios.put('/couriers/tenants/' + id + '/youzheng-auth', params)
  },

  // 2022-02-22
  printPick(id, params) {
    return axios.put('/couriers/tenants/' + id + '/print-pick', params)
  },
  // 2022-02-22
  cancelPrintPick(id, params) {
    return axios.put('/couriers/tenants/' + id + '/cancel-print-pick', params)
  },
  // 2022-03-02
  authorise(params) {
    return axios.put('/couriers/tenants/authorise', params)
  },

  // 2022-04-22
  dhlDpsOrod(id, params) {
    return axios.put('/couriers/tenants/' + id + '/dhl-dps-prod', params)
  },
  // 2022-10-26
  uploadLianbangSignImage(params) {
    return axios.post('/couriers/tenants/upload-lianbang-sign-image', params)
  },
  // 2022-10-26
  uploadLianbangLetterHead(params) {
    return axios.post('/couriers/tenants/upload-lianbang-letter-head', params)
  },
  // 2022-12-01
  amazonAuth() {
    return axios.get('/couriers/tenants/amazon-auth')
  },
  // 2022-12-01
  amazonAuthCodeToToken(params) {
    return axios.get('/couriers/tenants/amazon-auth-code-to-token', params)
  },
}

